export const fr = {
  title: `École`,
  p1: `En tant que parent, il est important d’aviser l’école que votre enfant est atteint de l’épilepsie. De plus, l’école devrait mettre en place un plan d’intervention individualisé pour votre enfant. Ce plan inclut divers renseignements tels que l’information sur le type d’épilepsie dont l’élève est atteint, le nom du médecin de l’enfant, sa liste de médicaments et les gestes à poser en cas de crises d’épilepsie.`,
  tellToSchool: {
    p1: `Quoi dire à l’enseignant pour aider mon enfant à l’école ?`,
    bullets: [
      `Rassurer et réconforter l’élève`,
      `Permettre à l’élève de se reposer si nécessaire`,
      `Permettre à l’élève de se rendre aux toilettes s’il y a eu perte des fonctions urinaires et/ou intestinales`,
      `Permettre à l’élève de se changer`,
      `Expliquer à l’élève ce qu’il a manqué en classe`,
      `Expliquer aux autres élèves ce qui s’est passé`,
      `Encourager les camarades à avoir une attitude positive et compréhensive`,
      `Continuer les activités régulières une fois que tout est rentré dans l’ordre`
    ]
  },
  schoolServices: {
    p1: `Les milieux scolaires offrent une panoplie de services pour aider votre enfant dans son cheminement scolaire. Il suffit de discuter des besoins de votre enfant auprès de son professeur. Voici une liste de services disponibles :`,
    bullets: [
      `Service de prise de note`,
      `Temps supplémentaire aux examens`,
      `Accès à un local adapté`,
      `Horaire adapté selon la prise de médication`,
      `Soutien pédagogique adapté (ex.: tutorat)`
    ]
  },
  p2: `Une question à laquelle votre enfant peut être confronté dans la cour de récréation est celle de savoir si les enfants atteints d’épilepsie sont moins intelligents ? La réponse à cette question est non. Les enfants qui ont l’épilepsie sont en moyenne aussi intelligents que les autres enfants. Certains enfants ayant l’épilepsie peuvent toutefois présenter des difficultés d’apprentissage en raison de la récurrence des crises ou à cause des effets indésirables des médicaments (ex.: somnolence, fatigue).`
};
